module.exports = __webpack_public_path__ + "static/media/ill_magbesvar_ovre.30161494.svg";